import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute
} from '@angular/router';
import { of } from 'rxjs/observable/of';

import { AuthService } from './auth.service';

@Injectable()
export class SessionDataResolver implements Resolve<any> {
  /**
   * Constructor
   *
   * @param _authService
   */
  constructor(
    private _authService: AuthService,
    private _activatedRoute: ActivatedRoute,
  ) {}

  /**
   *
   * @param route
   * @param state
   */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // const adminUrl = document.location.href.includes('admin');
    // const tokenType = adminUrl ? 'private-token' : 'public-token';
    // const queryToken = this._activatedRoute.snapshot.queryParams;
    // const token =
    //   (queryToken && queryToken.token) ||
    //   localStorage.getItem(tokenType) ||
    //   (await this.storage.get(tokenType));

    return this._authService.sessionData
      .toPromise()
      .then((res) => {
        return res;
      })
      .catch(() => {
        return of(null);
      });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/session-data-resolver.service.ts